import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Users, AudioWaveform, Settings, Download, ArrowRight } from 'lucide-react';

const WingApps = () => {
  const apps = [
    {
      name: 'WING EDIT',
      description: 'Controle remoto e mixagem offline completa',
      icon: Monitor,
      platforms: ['Windows', 'Mac', 'Linux'],
      color: 'yellow'
    },
    {
      name: 'CoPilot',
      description: 'Mixagem remota profissional para tablets',
      icon: Monitor,
      platforms: ['iOS', 'Android'],
      color: 'yellow'
    },
    {
      name: 'WING Q',
      description: 'Monitor mixing personalizado para músicos',
      icon: Users,
      platforms: ['iOS', 'Android'],
      color: 'yellow'
    },
    {
      name: 'LiveSessions',
      description: 'Converta gravações multi-track e prepare playback',
      icon: AudioWaveform,
      platforms: ['Windows', 'Mac', 'Linux'],
      color: 'yellow'
    },
    {
      name: 'StageConnect',
      description: 'Configure roteamento, cabos e necessidades de energia',
      icon: Settings,
      platforms: ['Windows', 'Mac', 'Linux'],
      color: 'yellow'
    }
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <div className="inline-block bg-yellow-500/10 border border-yellow-500/30 px-6 py-2 rounded-full mb-4">
              <span className="text-yellow-400 font-semibold text-sm">ECOSSISTEMA COMPLETO</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Domine todos os <span className="gradient-text">Apps WING</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              Aprenda a usar os 5 aplicativos oficiais gratuitos da Behringer
            </p>
          </div>

          {/* Apps Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {apps.map((app) => {
              const Icon = app.icon;
              return (
                <div
                  key={app.name}
                  className="glass p-6 rounded-xl card-hover group relative overflow-hidden"
                >
                  {/* Glow effect */}
                  <div className="absolute -top-20 -right-20 w-40 h-40 bg-yellow-500/10 rounded-full blur-3xl group-hover:bg-yellow-500/20 transition-all duration-300"></div>
                  
                  <div className="relative z-10">
                    <div className="w-14 h-14 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-yellow-500/20 transition-colors duration-300">
                      <Icon className="w-8 h-8 text-yellow-400" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{app.name}</h3>
                    <p className="text-gray-400 mb-4 text-sm">{app.description}</p>
                    
                    {/* Platforms */}
                    <div className="flex flex-wrap gap-2">
                      {app.platforms.map((platform) => (
                        <span
                          key={`${app.name}-${platform}`}
                          className="text-xs bg-white/5 text-gray-300 px-2 py-1 rounded"
                        >
                          {platform}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Special Card — leva para a página de Downloads */}
            <Link
              to="/downloads"
              data-testid="apps-gratuitos-card"
              className="glass p-6 rounded-xl group relative overflow-hidden bg-gradient-to-br from-yellow-500/10 to-transparent border border-yellow-500/20 hover:border-yellow-500/60 hover:scale-[1.02] transition-all duration-300 cursor-pointer block"
            >
              <div className="relative z-10">
                <div className="w-14 h-14 bg-yellow-500/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-yellow-500/30 transition-colors">
                  <Download className="w-8 h-8 text-yellow-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Central de Downloads</h3>
                <p className="text-gray-300 mb-4 text-sm">
                  Apps, firmwares e drivers oficiais para WING Rack, WING Compact e WING Full — tudo gratuito.
                </p>
                <div className="flex items-center gap-2 text-yellow-400 font-bold text-base group-hover:gap-3 transition-all">
                  ACESSAR DOWNLOADS
                  <ArrowRight className="w-5 h-5" />
                </div>
              </div>
            </Link>
          </div>

          {/* Bottom Info */}
          <div className="text-center glass-dark p-8 rounded-2xl">
            <p className="text-gray-300 text-lg mb-4">
              <span className="text-yellow-400 font-bold">Aulas práticas</span> ensinando você a configurar e usar cada aplicativo de forma profissional
            </p>
            <a
              href="#inscricao"
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-4 rounded-lg font-bold transition-all duration-300 hover:scale-105 glow-yellow"
            >
              QUERO APRENDER TUDO ISSO
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WingApps;
